import { ReferralProgramModel } from 'types/models';
import ApiService from 'services/ApiService';

class ReferralProgramService extends ApiService<ReferralProgramModel> {
        constructor() {
                super('referralprogram');
        }
}

export default new ReferralProgramService();
